module.exports = __webpack_public_path__ + "img/notification-inactive.5bba1e42.png";